import { ApReviewPage, ApSearchPage } from "./ap-pages";
import { HelpSearchPage } from "./help-search-page";
import { COMMAND_ROOT, type CommandPage } from "./pages";
import { PayrollPeriodsPage } from "./payroll-pages";
import {
  PayrollPeriodPage,
  PayrollSheetsPage,
  PayrollStatementsPage,
} from "./payroll-period-page";
import { ProfitabilityPage } from "./profitability-pages";

export const CommandMenuPage = ({
  page,
  query,
  onPush,
  onNavigate,
}: {
  page: Exclude<CommandPage, typeof COMMAND_ROOT>;
  query: string;
  onPush: (page: CommandPage) => void;
  onNavigate: (to: string) => void;
}) => {
  switch (page.kind) {
    case "payroll-periods":
      return <PayrollPeriodsPage onOpen={onPush} onNavigate={onNavigate} />;
    case "payroll-period":
      return (
        <PayrollPeriodPage
          start={page.start}
          label={page.label}
          aiRunId={page.aiRunId}
          icmRunId={page.icmRunId}
          onOpen={onPush}
          onNavigate={onNavigate}
        />
      );
    case "payroll-sheets":
      return (
        <PayrollSheetsPage
          start={page.start}
          aiRunId={page.aiRunId}
          onNavigate={onNavigate}
        />
      );
    case "payroll-statements":
      return (
        <PayrollStatementsPage
          start={page.start}
          icmRunId={page.icmRunId}
          onNavigate={onNavigate}
        />
      );
    case "profitability":
      return <ProfitabilityPage onNavigate={onNavigate} />;
    case "ap-invoices":
    case "ap-receipts":
      return (
        <ApSearchPage kind={page.kind} query={query} onNavigate={onNavigate} />
      );
    case "ap-review":
      return <ApReviewPage onNavigate={onNavigate} />;
    case "help":
      return <HelpSearchPage query={query} onNavigate={onNavigate} />;
    default: {
      const exhaustive: never = page;
      return exhaustive;
    }
  }
};
